import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState, RootState } from '../types/redux';
import { Auth } from '../types/misc';

export default function useAuth(): Auth | undefined {
  const { isAuthenticated, alias, email, firstName, lastName } = useSelector(
    (state: RootState): ApplicationState => state.application,
  );

  return useMemo(() => {
    if (!isAuthenticated) return undefined;
    return { alias: alias!, email: email!, firstName, lastName };
  }, [isAuthenticated, alias, email, firstName, lastName]);
}
